import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const enrichCnpj = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({ cnpj: z.string() }).parse(data))
  .handler(async ({ data }) => {
    const cnpj = data.cnpj.replace(/\D/g, "");
    
    // Server-side fetch to bypass CORS
    try {
      const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
      
      if (!response.ok) {
        return { success: false, error: "CNPJ não encontrado ou erro na API" };
      }
      
      const result = await response.json();
      
      // Map to consistent format
      return { 
        success: true, 
        data: {
          razao_social: result.razao_social,
          municipio: result.municipio,
          uf: result.uf,
          bairro: result.bairro,
          logradouro: result.logradouro,
          telefone: result.ddd_telefone_1,
          email: result.email,
          cnae_fiscal_descricao: result.cnae_fiscal_descricao,
          descricao_situacao_cadastral: result.descricao_situacao_cadastral
        },
        source: "api"
      };
    } catch (error) {
      console.error("CNPJ enrichment error:", error);
      return { success: false, error: "Erro na comunicação com a BrasilAPI" };
    }
  });
